import React from 'react';

import styles from './DINavigation.module.scss';

const DINavigation = (props) => (
    <div className={styles.Navigation}>
        <div className={styles.Navigation__wrapper}>
        {
            props.links &&
            props.links.map( (l, index) => (
                <a href={ `#${l.reference}` } className={ props.activeNav == l.reference ? 'active-nav' : '' } key={ index }>{ l.name }</a>
            ))
        }
        {
            props.donate &&
            <a href="https://donate.globalcitizenyear.org/give/190334/#!/donation/checkout" target="_blank" id={styles.sidebar__donate}><div className="button" style={{ marginTop: '0' }}>
                DONATE
            </div></a>
        }
        </div>
    </div>
)

export default DINavigation;



// WEBPACK FOOTER //
// ./src/components/WhatAboutCollege/DINavigation/index.js